import React from 'react'
import { Progress, TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import axios from 'axios';
import { LeaveOfYearAPI } from '../functions/LeaveRequestPage'
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import { Switch, Case, Default } from 'react-if'
import ErrorSwal from '../../components/SwalError'

const LeaveOfYearCrate = (props) => {

    const { t } = useTranslation()
    const currentLanguageCode = cookies.get('i18next') || 'en'

    const [activeTab, setActiveTab] = React.useState('1')
    const [lastYear, setLastYear] = React.useState([])
    const [thisYear, setThisYear] = React.useState([])
    // const [nextYear, setNextYear] = React.useState([])
    const cancelToken = React.useRef(null)
    const [error, setError] = React.useState(null)

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const getData = async (prop) => {
        try {

            const resp = await LeaveOfYearAPI(prop.EmpNO)
            setLastYear(resp.data.lastYear)
            setThisYear(resp.data.thisYear)
            // setNextYear(resp.data.nextYear)

            if (resp.data.activeYear.ANNUALCD === String(new Date().getFullYear() - 1)) {
                setActiveTab('1')
            }
            else if (resp.data.activeYear.ANNUALCD === String(new Date().getFullYear())) {
                setActiveTab('2')
            }
            else {
                setActiveTab('3')
            }

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }

    }
    React.useEffect(() => {
        cancelToken.current = axios.CancelToken.source();

        getData(props);

        return () => {
            cancelToken.current.cancel();
        };
    }, [props]);

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h4 className="card-title"> {t("t_l_of_year")} </h4>
                </div>
                <div className="card-content">
                    <div className="card-body">
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => { toggle('1'); }}
                                >
                                    {new Date().getFullYear() - 1}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === '2' })}
                                    onClick={() => { toggle('2'); }}
                                >
                                    {new Date().getFullYear()}
                                </NavLink>
                            </NavItem>
                            {/* <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === '3' })}
                                    onClick={() => { toggle('3'); }}
                                >
                                    {new Date().getFullYear() + 1}
                                </NavLink>
                            </NavItem> */}
                        </Nav>
                        <TabContent className="tab-content" activeTab={activeTab}>
                            <TabPane tabId="1">
                                {
                                    lastYear.map((thisY, index) => {
                                        return (
                                            <Row key={index}>
                                                <Row>
                                                    <Col md="12" style={{ marginTop: '20px' }}>
                                                        <label className="font-blue-dark">
                                                            <b>
                                                                <Switch>
                                                                    <Case condition={currentLanguageCode === 'en'}> {thisY.TYPENM} </Case>
                                                                    <Case condition={currentLanguageCode === 'th'}> {thisY.TYPENM2} </Case>
                                                                    <Case condition={currentLanguageCode === 'jp'}> {thisY.TYPENM3} </Case>
                                                                    <Default> {thisY.TYPENM} </Default>
                                                                </Switch>
                                                            </b>
                                                        </label>
                                                    </Col>
                                                </Row>
                                                <Col md="12">
                                                    <Progress className="mb-4" animated color="success" value={thisY.Percent} />
                                                </Col>
                                                <Row>
                                                    <Col md="8" style={{ marginTop: '-15px' }}>
                                                        <label className="font-blue-dark" style={{ marginTop: '-15px', fontSize: '0.6em' }}>
                                                            {t("t_use")} {thisY.UseDay}  {t("t_day")} {thisY.UseMin}
                                                        </label>
                                                    </Col>
                                                    <Col md="4" style={{ marginTop: '-15px' }}>
                                                        <label style={{ color: 'rgb(10 37 88)', float: 'right', fontSize: '0.5em', fontWeight: 'bold' }}>
                                                            {t("t_total")} {thisY.DEFULT_ANNUAL} {t("t_day")}
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        )
                                    })
                                }

                            </TabPane>
                            <TabPane tabId="2">
                                {
                                    thisYear.map((nextY, index) => {
                                        return (
                                            <Row key={index}>
                                                <Row>
                                                    <Col md="12" style={{ marginTop: '20px' }}>
                                                        <label className="font-blue-dark">
                                                            <b>
                                                                <Switch>
                                                                    <Case condition={currentLanguageCode === 'en'}> {nextY.TYPENM} </Case>
                                                                    <Case condition={currentLanguageCode === 'th'}> {nextY.TYPENM2} </Case>
                                                                    <Case condition={currentLanguageCode === 'jp'}> {nextY.TYPENM3} </Case>
                                                                    <Default> {nextY.TYPENM} </Default>
                                                                </Switch>
                                                            </b>
                                                        </label>
                                                    </Col>
                                                </Row>
                                                <Col md="12">
                                                    <Progress className="mb-4" animated color="success" value={nextY.Percent} />
                                                </Col>
                                                <Row>
                                                    <Col md="8" style={{ marginTop: '-15px' }}>
                                                        <label className="font-blue-dark" style={{ marginTop: '-15px', fontSize: '0.6em' }}>
                                                            {t("t_use")} {nextY.UseDay}  {t("t_day")} {nextY.UseMin}
                                                        </label>
                                                    </Col>
                                                    <Col md="4" style={{ marginTop: '-15px' }}>
                                                        <label style={{ color: 'rgb(10 37 88)', float: 'right', fontSize: '0.5em', fontWeight: 'bold' }}>
                                                            {t("t_total")} {nextY.DEFULT_ANNUAL} {t("t_day")}
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        )
                                    })
                                }
                            </TabPane>
                            {/* <TabPane tabId="3">
                                {
                                    nextYear.map((nextY, index) => {
                                        return (
                                            <Row key={index}>
                                                <Row>
                                                    <Col md="12" style={{ marginTop: '20px' }}>
                                                        <label className="font-blue-dark"><b>{nextY.TYPENM} </b> </label>
                                                    </Col>
                                                </Row>
                                                <Col md="12">
                                                    <Progress className="mb-4" animated color="success" value={nextY.Percent} />
                                                </Col>
                                                <Row>
                                                    <Col md="8" style={{ marginTop: '-15px' }}>
                                                        <label className="font-blue-dark" style={{ marginTop: '-15px', fontSize: '0.6em' }}>
                                                            Used {nextY.UseDay} Days {nextY.UseMin}
                                                        </label>
                                                    </Col>
                                                    <Col md="4" style={{ marginTop: '-15px' }}>
                                                        <label style={{ color: '#adadad', float: 'right', fontSize: '0.6em', fontWeight: 'bold' }}>
                                                            Total {nextY.DEFULT_ANNUAL} Days
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </Row>
                                        )
                                    })
                                }
                            </TabPane> */}
                        </TabContent>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LeaveOfYearCrate
